export const GET_DASHBOARD_DATA_REQUEST = 'GET_DASHBOARD_DATA_REQUEST';
export const GET_DASHBOARD_DATA_SUCCESS = 'GET_DASHBOARD_DATA_SUCCESS';
export const GET_DASHBOARD_DATA_FAILURE = 'GET_DASHBOARD_DATA_FAILURE';

export const GET_PORTFOLIO_DASHBOARD_REQUEST = 'GET_PORTFOLIO_DASHBOARD_REQUEST';
export const GET_PORTFOLIO_DASHBOARD_SUCCESS = 'GET_PORTFOLIO_DASHBOARD_SUCCESS';
export const GET_PORTFOLIO_DASHBOARD_FAILURE = 'GET_PORTFOLIO_DASHBOARD_FAILURE';
